import { IconsStore } from '@vezeeta/web-components';
import Icons from '@vezeeta/web-icons';

const ServicesToolIconsStore = new IconsStore(Icons);

export default ServicesToolIconsStore;
